import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import notification from 'antd/lib/notification';

import { CombinedState } from 'reducers';
import { saveAnnotationsAsync } from 'actions/annotation-actions';
import { t } from 'utils/i18n';

// leaving the job drops its in-memory annotations: save them first, stay if that fails
export function useSaveThenNavigate(): (path: string) => Promise<boolean> {
    const dispatch = useDispatch();
    const history = useHistory();
    const job = useSelector((state: CombinedState) => state.annotation.job.instance);
    return useCallback(async (path: string) => {
        if (job && job.annotations.hasUnsavedChanges()) {
            await dispatch(saveAnnotationsAsync() as any);
            if (job.annotations.hasUnsavedChanges()) {
                notification.error({ message: t('Your changes could not be saved'), description: t('Press Ctrl+S to try again.') });
                return false;
            }
        }
        history.push(path);
        return true;
    }, [dispatch, history, job]);
}
